// extracted by css-extract-rspack-plugin
export default {"container":"ymUV5mUsa_48xhhf","svg":"a2LtUnfIS8YdrZob","path":"qyRwBZgonOMLYSVM"};